import { render, staticRenderFns } from "./DigitalBusinessCards.vue?vue&type=template&id=cf77ea1a&"
import script from "./DigitalBusinessCards.vue?vue&type=script&lang=js&"
export * from "./DigitalBusinessCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports